/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "個人情報の販売・共有を許可しない",
      "Bumble Date",
      "アプリ一覧",
      "概要",
      "採用情報",
      "お問い合わせ",
      "株主・投資家の方へ",
      "ショップ",
      "会社情報",
      "アプリをダウンロード",
      "Bumbleのアクセシビリティについて",
      "ガイドライン",
      "Cookieの管理",
      "現代奴隷法",
      "個人情報収集時の通知",
      "プライバシーポリシー",
      "利用規約",
      "規約",
      "ワシントン州消費者健康データ・プライバシーポリシー",
      "QRコードをスキャンして、Bumbleのアプリをダウンロード",
      "契約のキャンセル",
      "メニューを閉じる",
      "メニューを開く",
      "言語選択",
      "フッター",
      "Bumbleのアクセシビリティ",
      "AppleとAppleロゴは、Apple Inc.の商標です。",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "採用情報",
      "Google Pay は Google LLC の商標です。",
      "ガイドライン",
      "株主・投資家の方へ",
      "Cookieの管理",
      "現代奴隷法に関する声明",
      "回収時の注意事項",
      "プライバシーポリシー",
      "季節ごとのデートガイド",
      "利用規約",
      "アプリ",
      "ワシントン州消費者健康データ・プライバシーポリシー",
      "概要",
      "アンバサダー",
      "友達をつくってコミュニティを探そう",
      "プロフェッショナルなネットワークを構築し、キャリアアップを目指そう",
      "真剣な交際相手、カジュアルな関係、その中間など様々な出会いを探そう",
      "The Buzz",
      "詳しくみる",
      "トラベルモードでグローバルに",
      "Date",
      "機能",
      "Compliments",
      "あなたのプロフィールが際立つように、お相手にComplimentsを送ってみましょう。",
      "見つける",
      "あなた用にカスタマイズしたページで相性抜群のお相手を紹介します。毎日更新されます。",
      "プライベートモード",
      "プライベートモードで上司、親戚、元恋人からプロフィールを隠せます。",
      "瞬間マッチ",
      "Bumbleのオフラインイベントをきっかけに会話が始まりましたか？アプリ上で会話を続けませんか。",
      "Opening Moves",
      "Opening Movesを選択して、マッチング相手からチャットを開始してもらうようにしましょう。そうすれば、あなたが開始する必要はありません。",
      "スヌーズモード",
      "スヌーズモードで出会いを一時休止できます。再び出会う準備ができた際にはすぐに再開できます。",
      "SuperSwipe",
      "バイブスに響くプロフィールがありましたか？SuperSwipeでそのことを伝えよう",
      "トラベルモード",
      "トラベルモードで、訪れた場所でお相手を見つけ、世界中どこででもマッチしましょう。",
      "ビデオ通話",
      "ビデオチャットや音声通話を利用して、対面で会う心の準備が整っているかを確認してみましょう。",
      "ウェブアプリ",
      "ブラウザでBumble体験をすぐに始めましょう。",
      "Bumbleアプリをダウンロード",
      "BFF",
      "安全性",
      "ストーリー",
      "サポート",
      "ショップ",
      "メイン",
      "印象付けられるように、お相手にComplimentsを送ってみましょう。",
      "Compliments",
      "実際的で、尊重し合えて、信頼し合える関係を築くためにデザインされた機能です。",
      "プロフィールを上司、親戚、元恋人等へ非公開にしましょう。",
      "プライベートモード",
      "スヌーズモードで出会いを一時的に休止しましょう。",
      "スヌーズモード",
      "気に入ったお相手を見つけましたか？お相手に知らせましょう。",
      "SuperSwipe",
      "Dateモードを探索しよう",
      "国境にとらわれずあらゆる場所でマッチングしましょう。",
      "トラベルモード",
      "家にいながら、お互いの顔を見ながら会話しましょう。",
      "ビデオ通話",
      "リーダーはBumbleの価値観を各地のコミュニティに浸透させるお手伝いをしています。",
      "コミュニティリーダー",
      "同じ趣味や興味を持つ人たちを探して、関係を築きやすくするための機能です。",
      "グループでの集まりを企画するか、近くで開催されている地域のイベントを探してみましょう。",
      "Plans",
      "BFFモードを試す",
      "愛と友情を見つけやすくするために必要な、すべてのアドバイスとアイデアを集めました。",
      "望んでいる友人関係を築くためのアドバイスと体験談です。",
      "出会いと交流のハブ",
      "東京からトロントまで、世界中で、Bumbleで見つけた愛を探索しましょう。",
      "愛のストーリー",
      "いつ、どこで、誰とデートするかを問わず、完璧なデートを計画しましょう。",
      "季節ごとのデートガイド",
      "ストーリーを探索しよう",
      "さらに読む",
      "{{social_network}}のBumble",
      "お問い合わせ",
      "ログイン",
      "(opens in new window)",
      "よくある質問",
      "Cookie Policy",
      "Bumble ー The Blog",
      "採用情報",
      "チャット",
      "都市",
      "クッキーの管理",
      "著作権 © 2006 – 現在。Bumble（不許複製・禁無断転載）",
      "デートの信頼度レポート",
      "AppleおよびAppleのロゴはApple Inc.の商標です。{{__EOL__}}Google PlayはGoogle LLCの商標です。",
      "ダウンロード",
      "Facebook",
      "フォローはこちらから",
      "ヘルプセンター",
      "Instagram",
      "言語",
      "LinkedIn",
      "BumbleはBumble Incの一部です。",
      "プライバシーポリシー",
      "Safety Centre",
      "サイトマップ",
      "現代奴隷法",
      "利用規約",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "時間"
            ],
            "singular": [
                  "時間"
            ]
      },
      "minute": {
            "plural": [
                  "分"
            ],
            "singular": [
                  "分"
            ]
      },
      "month": {
            "plural": [
                  "ヶ月"
            ],
            "singular": [
                  "ヶ月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
